import { observer } from "mobx-react";
import React from "react";
import { IOption } from "../Utils/Interface";
import Popover from "./Popover";
import { IValidationResult } from "../Stores/ProductConfigurationStore";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";

type Props = {
	headline: any;
	options: IOption[];
	selectedOptions: IOption[];
	selectionId: string;
	popoverDescription?: string;
	canSelectOption?: (option: IOption) => IValidationResult;
	onChange: (option: IOption) => void;
};

type State = {
	isPopoverOpen: boolean;
};

@observer
class CheckBoxArea extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isPopoverOpen: false,
		};
	}

	handlePopover = (e: any) => {
		e.preventDefault();

		this.setState({ isPopoverOpen: !this.state.isPopoverOpen });

		if (!this.state.isPopoverOpen) {
			document.body.style.overflowY = "hidden";
		} else {
			document.body.style.overflowY = "unset";
		}
	};

	onChange = (e: any) => {
		const id = e.target.value;
		if (id) {
			const option = this.props.options.find((o) => o.id === id);
			if (option) this.props.onChange(option);
		}
	};

	isChecked = (option: IOption) => {
		return this.props.selectedOptions.find((o) => o.id === option.id) ? true : false;
	};

	render() {
		return (
			<>
				<div className="selection-wrapper">
					<div className="selection-headline-wrapper mb-2 pb-4">
						<h4 className="selection-headline">{this.props.headline}</h4>
						{this.props.popoverDescription && <div className="module-popover" onClick={this.handlePopover}></div>}
						{typeof this.props.popoverDescription !== "undefined" && this.state.isPopoverOpen && (
							<Popover
								headline={this.props.headline}
								description={this.props.popoverDescription}
								position={"position-lg-relative"}
								onClose={() => {
									this.setState({ isPopoverOpen: !this.state.isPopoverOpen });
									if (!this.state.isPopoverOpen) {
										document.body.style.overflowY = "hidden";
									} else {
										document.body.style.overflowY = "unset";
									}
								}}
							/>
						)}
					</div>
					<div className="multi-select-selection">
						{this.props.options?.map((option, index) => {
							const validationResult = this.props.canSelectOption ? this.props.canSelectOption(option) : undefined;
							const disabledClass = validationResult?.valid === false ? "disabled" : ""; // set disabled if validation result is false
							return (
								<div key={`${index}-checkbox`} className="multi-select-check">
									<label className={`multi-select-label ${disabledClass}`}>
										<input
											type="checkbox"
											className="multi-select-check-input"
											value={option.id}
											disabled={validationResult?.valid === false}
											onChange={(e) => this.onChange(e)}
											checked={this.isChecked(option)} // is selected function
										/>
										<span>{option.name}</span>

										{validationResult?.valid === false && (
											<div className="tooltip-incompatible-text">
												<div className="arrow"></div>
												{generalConfigurationStore.configs?.generalIncompatibleText}{" "}
												{validationResult.reason.modules
													.map((module) => {
														return module.title;
													})
													.join(", ")}
											</div>
										)}
									</label>
								</div>
							);
						})}
					</div>
				</div>
			</>
		);
	}
}

export default CheckBoxArea;
